import { Type } from 'class-transformer';
import { IsNotEmpty, IsArray } from 'class-validator';

import { VacationApprover } from './vacation-approver.dto';

const notEmptyOptions = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class CreateVacationCoordinationDto {
  @Type(() => VacationApprover)
  @IsArray()
  @IsNotEmpty(notEmptyOptions)
  approvers: VacationApprover[];
}
